import { createContext, useState } from 'react'
import PropTypes from 'prop-types'
// create context
const LoaderContext = createContext()

const LoaderContextProvider = ({ children }) => {
  const [showLoader, setShowLoader] = useState(false)
  return (
    <LoaderContext.Provider value={{ showLoader, setShowLoader }}>
      {children}
    </LoaderContext.Provider>
  )
}

LoaderContextProvider.propTypes = {
  children: PropTypes.PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node
  ]).isRequired
}

export { LoaderContext, LoaderContextProvider }
